import {
  createEntityAdapter,
  createSlice,
  type EntityState,
  type PayloadAction,
} from "@reduxjs/toolkit";

type BrandsOrderMapping = Record<string, number[]>;

const initialState: BrandsOrderMapping = {};

export const brandsOrderMappingSlice = createSlice({
  name: "brandsOrderMapping",
  initialState,
  reducers: {
    setBrandsMapping: (state, action: PayloadAction<BrandsOrderMapping>) => {
      state = action.payload as any;
      return state;
    },
    setBrandsMappingForMarket: (
      state,
      action: PayloadAction<{ marketId: number; order: number[] }>
    ) => {
      state[action.payload.marketId] = action.payload.order;
      return state;
    },
  },
});

export const { setBrandsMapping, setBrandsMappingForMarket } =
  brandsOrderMappingSlice.actions;

export default brandsOrderMappingSlice.reducer;
